import { FC } from "react";
import withPage from "../../components/Page";
import Section from "../../components/Section";
import Hero from "../../components/Hero";
import Button from "../../components/Button";
import CtaSection from "../../components/CtaSection";
import { globalContent } from "../../config/content";
import styles from "./Contact.module.scss";

const Contact: FC = () => {
  const emailAddress = globalContent.contact.email;

  return (
    <div className={styles.contactPage}>
      {/* 1. Hero */}
      <Hero
        eyebrow="Contact"
        heading="Get in touch."
        copy={`Have a question about Pulse, building information or how the platform could work for your organisation?

Get in touch and we'll be happy to help.`}
        backgroundImage={require("../../assets/images/building/contact-building.webp")}
        button={{
          text: "Request a Demo",
          to: "/request-a-demo",
          variant: "secondary",
        }}
        secondaryButton={{
          text: "Email Us",
          href: `mailto:${emailAddress}`,
          variant: "outlineLight",
        }}
      />

      {/* 2. Email us */}
      <Section bgColor="off-white">
        <div className={styles.sectionContent}>
          <span className={styles.eyebrow}>Contact us</span>
          <h2 className={styles.sectionHeading}>Send us an email</h2>
          <p className={styles.sectionCopy}>
            You can contact us using the details below.
          </p>

          <div className={styles.contactCard}>
            <div className={styles.contactField}>
              <span className={styles.fieldLabel}>Email</span>
              <a href={`mailto:${emailAddress}`} className={styles.emailLink}>
                {emailAddress}
              </a>
            </div>
            <div className={styles.actionContainer}>
              <Button
                href={`mailto:${emailAddress}`}
                variant="primary"
                size="md"
              >
                Email us
              </Button>
            </div>
          </div>
        </div>
      </Section>

      {/* 3. Final CTA (Request a Demo) */}
      <CtaSection
        eyebrow="Demonstration"
        heading="Looking for a demonstration?"
        copy="If you'd like to see Pulse in action, request a demonstration and we'll show you how the platform can help bring your building information together."
        button={{
          text: "Request a Demo",
          to: "/request-a-demo",
          variant: "secondary",
        }}
      />
    </div>
  );
};

export default withPage(Contact)({
  meta: globalContent.seo.contact,
});
